import Styles from "./User.module.scss";
import clsx from "clsx";
import PaginationComponent from "../../../Share/Component/Pagination";
import TableComponent from "../../../Share/Component/Table";
import { USER_TABLE_COLUMNS } from "../../../Constants/user";
import { useUsersPage } from "../../../Hooks/useUsersPage";
import AdminModal from "../../../Components/Atoms/Modal";
import AddKNBForm from "../../../Components/Molecules/AddKNBForm";
import { getItemDescription } from "../../../Utils/formatItem";
import AddItemForm from "../../../Components/Molecules/AddItemForm";
import { formatDate, formatProfileDay } from "../../../Utils/index";
import { useCallback, useState } from "react";

const USER_STATUS = {
  ACTIVE: "ACTIVE",
  LOCKED: "LOCKED",
};

const USER_STATUS_LABEL = {
  [USER_STATUS.ACTIVE]: "Hoạt động",
  [USER_STATUS.LOCKED]: "Đã khóa",
};

const getUserStatusKey = (user) =>
  String(
    user?.Id ??
      user?.ID ??
      user?.id ??
      user?.UserId ??
      user?.Name ??
      user?.Email ??
      JSON.stringify(user)
  );

const getInitialFakeUserStatus = (user) => {
  const source = getUserStatusKey(user);
  const score = source
    .split("")
    .reduce((total, character) => total + character.charCodeAt(0), 0);

  return score % 2 === 0 ? USER_STATUS.ACTIVE : USER_STATUS.LOCKED;
};

function AdminUser() {
  const [fakeUserStatuses, setFakeUserStatuses] = useState({});
  const {
    search,
    users,
    isShowKnbModal,
    paging,
    user,
    items,
    handleShowKnbModal,
    handleCloseKnbModal,
    getListUsers,
    setSearch,
  } = useUsersPage();

  const getUserStatus = useCallback(
    (row) => {
      const statusKey = getUserStatusKey(row);

      return fakeUserStatuses[statusKey] ?? getInitialFakeUserStatus(row);
    },
    [fakeUserStatuses]
  );

  const handleToggleFakeStatus = useCallback((event, row) => {
    event.stopPropagation();

    setFakeUserStatuses((prev) => {
      const statusKey = getUserStatusKey(row);
      const currentStatus = prev[statusKey] ?? getInitialFakeUserStatus(row);

      return {
        ...prev,
        [statusKey]:
          currentStatus === USER_STATUS.LOCKED
            ? USER_STATUS.ACTIVE
            : USER_STATUS.LOCKED,
      };
    });
  }, []);

  return (
    <div className={clsx(Styles.main, "flex-grow-1")}>
      <div className={clsx(Styles.bodyMain, "container-fluid my-1")}>
        <div className={clsx(Styles.bodyMainTop)}>
          <div className={clsx(Styles.filterWrap)}>
            <div className={clsx(Styles.searchWrap)}>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className={clsx(Styles.Search)}
              />
              <span
                onClick={() => getListUsers(0)}
                className={clsx(Styles.contentSearch)}
              >
                Search
              </span>
            </div>
          </div>
        </div>
        <div className={clsx(Styles.table)} id="style-3">
          <TableComponent
            data={users}
            header={USER_TABLE_COLUMNS}
            onRowClick={handleShowKnbModal}
            customFormatters={{
              Item: (value) => getItemDescription(items, value),
              DateOfBirth: formatProfileDay,
              CreatedDate: formatDate,
              IP: (_value) => "118.71.220.179",
              Status: (row, _key) => {
                const status = getUserStatus(row);

                return (
                  <span
                    className={clsx(
                      Styles.statusBadge,
                      status === USER_STATUS.LOCKED
                        ? Styles.statusLocked
                        : Styles.statusActive
                    )}
                  >
                    {USER_STATUS_LABEL[status]}
                  </span>
                );
              },
              Action: (row, _key) => {
                const status = getUserStatus(row);
                const isLocked = status === USER_STATUS.LOCKED;

                return (
                  <button
                    type="button"
                    className={clsx(
                      Styles.actionButton,
                      isLocked ? Styles.unlockButton : Styles.lockButton
                    )}
                    onClick={(event) => handleToggleFakeStatus(event, row)}
                  >
                    {isLocked ? "Mở khóa" : "Khóa"}
                  </button>
                );
              },
            }}
          />
        </div>
        <div className={clsx(Styles.footer)}>
          <div className={clsx(Styles.footerWrap)}>
            <PaginationComponent page={paging} handleCallApi={getListUsers} />
          </div>
        </div>
      </div>
      {isShowKnbModal && (
        <AdminModal
          title={`Thêm KNB - ${user.Name}`}
          isShow={isShowKnbModal}
          handleCloseModal={handleCloseKnbModal}
        >
          <div className={clsx(Styles.modal)}>
            <AddKNBForm user={user} handleCloseKnbModal={handleCloseKnbModal} />
            <hr />
            <AddItemForm
              user={user}
              handleCloseKnbModal={handleCloseKnbModal}
              items={items}
            />
          </div>
        </AdminModal>
      )}
    </div>
  );
}

export default AdminUser;
